/*
* This is not CardListV2,
* but mere a replica of CardV1 created due to US-India HP issues
*/

import React from 'react';
import Link from 'components/Link';
import { convertHtmlToStringText } from 'utils/common';
import Card from '../CardV2';
import MediaIcon from './MediaIcon';

function renderTimeStamp(item, timeStampFun, timeStampFormat) {
  let timestampHtml = null;
  const timestamp = item.upd || item.lpt || item.dl || null;
  if (timestamp && timeStampFun && timeStampFormat) {
    timestampHtml = timeStampFun(timestamp, timeStampFormat);
  }
  return timestampHtml;
}

function clubGAindex(newga, index, url) {
  const spaceRemoverGA = newga.replace(/ /g, '');
  const updated = `${spaceRemoverGA + index}#${url}`;
  return updated;
}

function renderList(
  data,
  nonFeaturedItemWrapperClass,
  itemClass,
  nonFeaturedListTileType = 'isVerticalTile',
  newga,
  htmlKeys,
  imgFit,
  imgWidth,
  isInlineSmallIconCard,
  isMoreStoriesListingCard,
  timeStampFun,
  timeStampFormat,
  hideImage,
  showDuration,
  showPhotosCount,
  backButtonGaOffset,
  ga4Type,
  ga4Category,
) {
  return (
    data instanceof Array &&
    data.map((item, index) => {
      const spotlightGA =
        item.ag && item.ag === 'spotlight'
          ? `sl_${index + 1}_${item.id}`
          : null;
      if (item.tn !== 'featured') {
        return (
          <div
            className={nonFeaturedItemWrapperClass}
            key={`non_featured_${index}`}
          >
            {hideImage ||
            !(
              typeof item.image === 'object' ||
              (item.imageid && item.imagesize) ||
              item.imageUrl
            ) ? (
              <>
                <MediaIcon type={item.type} />
                <Link
                  to={item.wu}
                  className={itemClass}
                  data-newga={`${newga}${index}/${item.wu}`}
                  rel={item.rel}
                  ga4Data={
                    ga4Type && [
                      {
                        event: 'user_click',
                        type: `${ga4Type}`,
                        category: `${ga4Category || 'story_click'}`,
                        story_no: `${index + 1}`,
                        msid: item?.id,
                      },
                    ]
                  }
                >
                  {htmlKeys &&
                  htmlKeys instanceof Array &&
                  htmlKeys.indexOf('hl') > -1
                    ? convertHtmlToStringText(item.hl)
                    : item.hl}
                </Link>
              </>
            ) : (
              [
                nonFeaturedListTileType !== 'isVerticalTile' ? (
                  <Card
                    data={item}
                    itemClass={itemClass}
                    tileType="nonFeaturedListTileType"
                    newga={
                      backButtonGaOffset
                        ? `click-${backButtonGaOffset + index + 1}-${
                            item.wu
                          }#${newga}`
                        : clubGAindex(newga, index + 1, item.wu)
                    }
                    htmlKeys={htmlKeys}
                    imgFit={imgFit}
                    imgWidth={imgWidth}
                    key={item.id || `${item.tn}_${index}`}
                    isInlineSmallIconCard={isInlineSmallIconCard}
                    isMoreStoriesListingCard={isMoreStoriesListingCard}
                    timeStampHtml={renderTimeStamp(
                      item,
                      timeStampFun,
                      timeStampFormat,
                    )}
                    showDuration={showDuration}
                    showPhotosCount={showPhotosCount}
                    viewga={spotlightGA}
                    ga4Category={ga4Category}
                    ga4Type={ga4Type}
                    gaIndex={index + 1}
                  />
                ) : (
                  <Card
                    data={item}
                    itemClass={itemClass}
                    isVerticalTile
                    newga={
                      backButtonGaOffset
                        ? `click-${backButtonGaOffset + index + 1}-${
                            item.wu
                          }#${newga}`
                        : clubGAindex(newga, index + 1, item.wu)
                    }
                    htmlKeys={htmlKeys}
                    imgFit={imgFit}
                    imgWidth={imgWidth}
                    key={item.id || `${item.tn}_${index}`}
                    isInlineSmallIconCard={isInlineSmallIconCard}
                    isMoreStoriesListingCard={isMoreStoriesListingCard}
                    timeStampHtml={renderTimeStamp(
                      item,
                      timeStampFun,
                      timeStampFormat,
                    )}
                    showDuration={showDuration}
                    showPhotosCount={showPhotosCount}
                    viewga={spotlightGA}
                    ga4Category={ga4Category}
                    ga4Type={ga4Type}
                    gaIndex={index + 1}
                  />
                ),
              ]
            )}
          </div>
        );
      }
      return null;
    })
  );
}

function CardList(props) {
  const {
    data = [],
    showDescription,
    nonFeaturedListWrapperClass,
    nonFeaturedItemWrapperClass,
    itemClass,
    featuredCardType,
    nonFeaturedListTileType,
    htmlKeys,
    imgFit,
    imgWidth,
    isInlineSmallIconCard = false,
    isMoreStoriesListingCard = false,
    timeStampFun,
    timeStampFormat,
    featuredItemClass,
    hideImage,
    showDuration = true,
    showPhotosCount = true,
    newga,
    backButtonGaOffset = undefined,
    ga4Type,
    ga4Category,
  } = props;
  const featured =
    data instanceof Array &&
    data.filter(item => (item.tn === 'featured' ? item : null));

  return (
    <>
      {data instanceof Array &&
        featured.map((item, index) => {
          const spotlightGA =
            item.ag && item.ag === 'spotlight'
              ? `sl_${index + 1}_${item.id}`
              : null;
          return (
            <Card
              data={item}
              showLiveBtn
              showDescription={showDescription}
              itemClass={`${featuredItemClass} ${itemClass}`}
              isLeadTypeTwo
              isVerticalTile={featuredCardType === 'isVerticalTile'}
              newga={`${newga}0/${item.wu}`}
              htmlKeys={htmlKeys}
              imgFit={imgFit}
              imgWidth={imgWidth}
              key={item.id || `${item.tn}_${index}`}
              timeStampHtml={renderTimeStamp(
                item,
                timeStampFun,
                timeStampFormat,
              )}
              showDuration={showDuration}
              showPhotosCount={showPhotosCount}
              viewga={spotlightGA}
              ga4Category={ga4Category}
              ga4Type={ga4Type}
              gaIndex={index + 1}
            />
          );
        })}
      {nonFeaturedListWrapperClass ? (
        <div className={nonFeaturedListWrapperClass}>
          {renderList(
            data,
            nonFeaturedItemWrapperClass,
            itemClass,
            nonFeaturedListTileType,
            newga,
            htmlKeys,
            imgFit,
            imgWidth,
            isInlineSmallIconCard,
            isMoreStoriesListingCard,
            timeStampFun,
            timeStampFormat,
            hideImage,
            showDuration,
            showPhotosCount,
            backButtonGaOffset,
            ga4Type,
            ga4Category,
          )}
        </div>
      ) : (
        renderList(
          data,
          nonFeaturedItemWrapperClass,
          itemClass,
          nonFeaturedListTileType,
          newga,
          htmlKeys,
          imgFit,
          imgWidth,
          isInlineSmallIconCard,
          isMoreStoriesListingCard,
          timeStampFun,
          timeStampFormat,
          hideImage,
          showDuration,
          showPhotosCount,
          backButtonGaOffset,
          ga4Type,
          ga4Category,
        )
      )}
    </>
  );
}

export default CardList;
